require('./RARejected.scss');

// @ vendors
const React = require('react');
// @ components
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';

class RARejected extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { title, subtitle, onPrevAction, onContinueAction } = this.props;

        return (
            <div className="robo-rejected prospects-step-content basic-layering">
                <div className="robo-rejected__wrapper">
                    <div className="robo-rejected__title">
                        <span>{title}</span>
                    </div>
                    <div className="dash-wrapper">
                        <span className="dash" />
                    </div>
                    <div className="robo-rejected__subtitle">
                        <span>{subtitle}</span>
                    </div>
                </div>
                <div className="steps-view__footer">
                    <div className="col-lg-12">
                        <RoadmapNavigation
                            buttonPrevSpecialHidden={true}
                            buttonPrevHidden={false}
                            buttonPrevAction={onPrevAction}
                            buttonContinueAction={onContinueAction}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = RARejected;
module.exports = RARejected;
